import axios from "axios";

// Config goes here

export default axios;
